module.exports = __webpack_public_path__ + "9bbf5800dc27e0ccc38c344b69f19a40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-cat-got-it2.png
// module id = 2022
// module chunks = 4